import Enums from 'utils/EnumsManager';

const { INVOICE } = Enums.REDUX_ACTION_TYPE_PREFIX;

export const RESET = `${INVOICE}_RESET`;



// WEBPACK FOOTER //
// ./src/views/Invoice/flow/actionTypes.js